<template>
  <div id="app">
    <HeaderPart id="header-part"/>
    <Menu/>
    <div id='main-part'>
        <router-view />
    </div>
    <div id='footer-part'>
        <FooterPart />
    </div>
    

     
  </div>
</template>

<script>
import HeaderPart from '@/layout/header'
import FooterPart from '@/layout/footerNew'
import Menu from '@/layout/menu'
export default {
  name: 'App',
  data(){
    return{

    }
  },


  components:{
    FooterPart,
    HeaderPart,
    Menu
  },
};


</script>

<style>
body{
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
  text-align: center;
  position: relative;
  background-color: #FBFCFE;
}



#header-part{
  z-index:9;
}


#main-part{
  box-sizing: border-box;
  border:1px #D1D3D4 solid;
  width:1200px;
  min-height:600px;
  margin: auto;
  background: white;
}

#footer-part{
  box-sizing: border-box;
  border:1px #D1D3D4 solid;
  width:1200px;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue